import type { JSX } from '@gov-design-system-ce/components/dist/types/components';
import { useTruncatedText } from '@gov-nx/core/hooks';
import type { Optional } from '@gov-nx/core/types';
import { ToggleButton } from '@gov-nx/ui/web';

interface EPetitionTextProps {
	text: Optional<string>;
	maxCharacters?: number;
	maxParagraphs?: number;
	toggleSize?: JSX.GovButton['size'];
	strings: {
		showMore: string;
		showLess: string;
	};
}

export const EPetitionText = ({
	text,
	maxCharacters = 400,
	maxParagraphs = 5,
	toggleSize = 'm',
	strings,
}: EPetitionTextProps) => {
	const { displayedParagraphs, shouldShowToggle, toggleExpand, expanded } =
		useTruncatedText(text ?? '', maxCharacters, maxParagraphs);

	if (!displayedParagraphs.length) return null;

	if (!shouldShowToggle) {
		return (
			<div>
				{displayedParagraphs.map((text) => (
					<p key={text}>{text}</p>
				))}
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-0">
			<div className="mt-4">
				{expanded ? null : (
					<div>
						{displayedParagraphs.map((text) => (
							<p key={text}>{text}</p>
						))}
					</div>
				)}
				<ToggleButton
					showLabel={strings.showMore}
					hideLabel={strings.showLess}
					onOpenChange={toggleExpand}
					direction="up"
					size={toggleSize}>
					{displayedParagraphs.map((text) => (
						<p key={text}>{text}</p>
					))}
				</ToggleButton>
			</div>
		</div>
	);
};
